import { useProductPositionProductInformationByShareLinkQuery } from "entities/product-positions/graphql/queries.generated"
import { useEnrichedProductInformation } from "entities/products/model/useEnrichedProductInformation"

interface UseSharedProductPositionProductInformationArgs {
  id: string
  projectShareID: string
}

export function useSharedProductPositionProductInformation({
  id,
  projectShareID
}: UseSharedProductPositionProductInformationArgs) {
  const { data, loading } =
    useProductPositionProductInformationByShareLinkQuery({
      variables: { id, projectShareID }
    })

  const productInformation = useEnrichedProductInformation(
    data?.productPositionProductInformationByShareLink
  )

  return { productInformation, isLoading: loading }
}
